import { useContext, useState } from "react";
import { useHistory } from "react-router-dom";
import { Button, Form } from "antd";
import axios from "axios";

import DocumentationContext from "../store/documentation-context";
import { parseYear } from "../services/forms";

import ContactForm from "../components/contact/contact-form";
import Card from "../components/ui/card";
import Content from "../components/ui/content";
import Header from "../components/ui/header";
import Footer from "../components/ui/footer";
import Stepper from "../components/ui/stepper";

const ContactPage = () => {
  const history = useHistory();
  const [form] = Form.useForm();

  const documentationCtx = useContext(DocumentationContext);
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState(false);

  const onBack = () => {
    history.push("/files");
  };

  const onSubmit = async () => {
    const values = form.getFieldValue();

    debugger;
    if (!values.telefono && !values.email) {
      setAlert(true);
      return;
    }

    setAlert(false);

    const data = {
      numero: documentationCtx.numero,
      anio: parseInt(parseYear(documentationCtx.anio)),
      documento: documentationCtx.documento,
      files: documentationCtx.archivos.filter((file) => !file.exceeded),
      telefono: values.telefono,
      email: values.email
    };

    try {
      setLoading(true);
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/documentacion`,
        data
      );
      setLoading(false);

      if (response) {
        documentationCtx.updateForm("", "", "");
        documentationCtx.updateArchivos([]);
        history.push("/finished");
      } else {
        history.push("/error");
      }
    } catch (error) {
      history.push("/error");
    }
  };
 
  return (
    <Card>
      <Header />
      <Content>
        <Stepper />
        <ContactForm form={form} alert={alert} />
      </Content>
      <Footer>
        <Button type="secondary" onClick={onBack}>
          Volver
        </Button>
        <Button type="primary" onClick={onSubmit} loading={loading}>
          {loading ? "Finalizando..." : "Finalizar"}
        </Button>
      </Footer>
    </Card>
  );
};

export default ContactPage;
